import { $getNodeByKey } from 'lexical'
import { createStore } from 'zustand'

import { $isLinkNode } from '../../../../nodes/LinkNode'

import { LinkCardOptions, LinkCardStore } from './interface'

export const createLinkCardStore = ({ editor }: LinkCardOptions) =>
  createStore<LinkCardStore>((set, get) => ({
    editor,
    nodeKey: '',
    text: undefined,
    url: undefined,
    icon: undefined,
    updateLinkNode() {
      const { editor, nodeKey, url, text, icon } = get()
      editor.update(() => {
        const linkNode = $getNodeByKey(nodeKey)
        if ($isLinkNode(linkNode)) {
          linkNode.setState({ url, icon })
          linkNode.setTextContent(text)
        }
      })
    },
    readStateFromNode(nodeKey) {
      get()
        .editor.getEditorState()
        .read(() => {
          const node = $getNodeByKey(nodeKey)
          if ($isLinkNode(node)) {
            set({
              nodeKey,
              text: node.getTextContent(),
              ...node.getState()
            })
          }
        })
    },
    syncFormData(values) {
      set({
        ...values,
        text: values.text ?? values.url
      })
    },
    formVisible: false,
    openForm(nodeKey) {
      const { toggleFormVisible, toggleToolbarVisible, readStateFromNode } =
        get()
      readStateFromNode(nodeKey)
      toggleToolbarVisible(false)
      toggleFormVisible(true)
    },
    closeForm(nodeKey) {
      const { formVisible, nodeKey: currentKey } = get()
      if (formVisible && nodeKey === currentKey) {
        set({ formVisible: false })
      }
    },
    toggleFormVisible(visible) {
      const formVisible = visible ?? !get().formVisible
      set({ formVisible })
      if (!formVisible) {
        get().editor.focus()
      }
    },
    toolbarVisible: false,
    openToolbar(nodeKey) {
      const {
        nodeKey: currentKey,
        formVisible,
        readStateFromNode,
        toggleToolbarVisible
      } = get()
      if (nodeKey === currentKey && formVisible) {
        return
      }
      readStateFromNode(nodeKey)
      toggleToolbarVisible(true)
    },
    toggleToolbarVisible(visible) {
      const toolbarVisible = visible ?? !get().toolbarVisible
      set({ toolbarVisible })
    },
    closeToolbar(nodeKey) {
      const { toolbarVisible, nodeKey: currentKey } = get()
      if (toolbarVisible && nodeKey === currentKey) {
        set({ toolbarVisible: false })
      }
    }
  }))
